"use client";
import { Card, CardContent, Stack, Switch, Typography, useScrollTrigger } from "@mui/material";
import CategoriesSideFilter from "./SearchSideFilters/CategoriesSideFilter";
import ColorsSideFilter from "./SearchSideFilters/ColorsSideFilter";
import BrandsSideFilter from "./SearchSideFilters/BrandsSideFilter";
import { useSiteSearchContext } from "./SiteSearchContext";
import PriceRangeSideFilter from "./SearchSideFilters/PriceRangeSideFilter";
import SearchFiltersSideCardSearchTextField from "./SearchFiltersSideCardSearchTextField";
import { useAppContext } from "../AppProvider";

export default function SearchFiltersSideCard() {
  const trigger = useScrollTrigger();
  const { hasBanner, bannerOptions } = useAppContext();
  const {
    hasOffer,
    inStock,
    handleHasOfferChange,
    handleInStockChange,
    targetCategory,
    colors,
    brands,
    categoryNodes,
  } = useSiteSearchContext();

  return (
    <>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          position: "sticky",
          overflow: "auto",
          transition: "0.3s all",
          top: trigger
            ? `${88 + (hasBanner ? bannerOptions.sx.minHeight.sm : 0)}px`
            : `${158 + (hasBanner ? bannerOptions.sx.minHeight.sm : 0)}px`,
          boxShadow: "-3px 0px 24px -6px rgba(232, 217, 207, 0.12), 3px 6px 24px -6px rgba(232, 217, 207, 0.16)",
        }}
      >
        <CardContent>
          <Typography variant="h6">فیلتر‌‌ها</Typography>
          <SearchFiltersSideCardSearchTextField />
        </CardContent>
        {categoryNodes && categoryNodes.length > 0 && (
          <CategoriesSideFilter categories={categoryNodes} targetCategory={targetCategory}></CategoriesSideFilter>
        )}
        {brands && brands.length > 0 && <BrandsSideFilter />}
        {colors && colors.length > 0 && <ColorsSideFilter />}
        <PriceRangeSideFilter />
        <Stack>
          <Stack sx={{ p: 2 }} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Typography>فقط کالاهای موجود</Typography>
            <Switch
              checked={inStock || false}
              color="secondary"
              onChange={(e) => {
                handleInStockChange(!inStock, false);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Stack>

          <Stack sx={{ p: 2 }} direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
            <Typography>فقط کالاهای تخفیف دار</Typography>
            <Switch
              checked={hasOffer || false}
              color="secondary"
              onChange={(e) => {
                handleHasOfferChange(!hasOffer, false);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Stack>
        </Stack>
      </Card>
    </>
  );
}
